import { SVGProps } from "react";

interface ArrowHorizontalProps extends SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
}

const ArrowHorizontal = ({ width = 24, height = 18, ...props }: ArrowHorizontalProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 18"
    {...props}
  >
    <path
      stroke="#383C40"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1.5 8.996h21M9 16.5 1.498 8.998 9 1.497"
    />
  </svg>
);
export default ArrowHorizontal;
